const langHandler = {
	methods:{
		setCookie(name,value,days) {
			var expires = "";
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days*24*60*60*1000));
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + (value || "")  + expires + "; path=/";
		},
		getCookie(name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for(var i=0;i < ca.length;i++) {
				var c = ca[i];
				while (c.charAt(0)==' ') c = c.substring(1,c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
			}
			return null;
		},
		defineLanguage(){
			const 	self = this;
			const 	lang = navigator.language, 
					routeLang = self.$route.meta.lang,
					frPath = self.$route.meta.frPath,
					enPath = self.$route.meta.enPath,
					id = self.$route.params.id;
			if(lang == 'fr' && routeLang != 'fr'){
				if(self.$route.name != 'Project'){
					self.$router.push({ path: frPath }); 
				}else{
					self.$router.push({ path: frPath+'/'+id }); 
				}
			}else if(lang == 'en' && routeLang != 'en'){
				if(self.$route.name != 'Project'){
					self.$router.push({ path: enPath }); 
				}else{
					self.$router.push({ path: enPath+'/'+id }); 
				}
			}
		},
	}
}

export default langHandler